import styled from 'styled-components';
import { TypographyWithIcon } from 'core/typography-with-icon';

export const StyledLeftMenuItem = styled(TypographyWithIcon)`
  &:hover {
    text-decoration: none;
  }
`;
